import React, { useState } from 'react';
import { auth } from './firebaseconfig'; // Update the path as needed
import { sendPasswordResetEmail, signInWithEmailAndPassword } from 'firebase/auth';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Style/login.css'; // Import your CSS file for styling
import {  useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [resetEmail, setResetEmail] = useState('');

  const navigate = useNavigate(); // Hook for navigation

  const handleLogin = async () => {
    if (!email || !password) {
      toast.error('Please enter both email and password.');
      return;
    }

    try {
      await signInWithEmailAndPassword(auth, email, password);
      toast.success('Login Successful! Welcome back!');
      navigate('/main'); 
    } catch (error) {
      toast.error(`Invalid Username or Password: ${error.message}`);
    }
  };

 

  return (
    <div className='login'>
    <div className="container">
      <h1 className="header">Login</h1>
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="input"
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        className="input"
      />
      <button className="loginButton" onClick={handleLogin}>Login</button>
      
     

      <ToastContainer />
    </div>
    </div>
  );
};

export default Login;
